import { getCustomer } from "@/graphql/schemas/shared/utils/getCustomer"
import { CommerceService } from "@/services/commerce"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { findCustomerTargetAddress } from "../utils/customerAddressInformation"

export const mutationRemoveDefaultBillingAddress = {
  async removeDefaultBillingAddress(parent, args, context, info) {
    const { customerId, customerKey, addressId, customerNumber } = args
    const commerceApi = CommerceService.api()
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.ADDRESSES,
      operation: Operations.UPDATE,
    })

    const customer = await getCustomer({ id: customerId, key: customerKey, number: customerNumber })

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customer.customerNumber,
    })
    const targetAddress = findCustomerTargetAddress(customer, addressId)

    if (!targetAddress) return null

    // nothing to do
    if (!targetAddress.isDefaultBilling || !targetAddress.isBillingAddress) return targetAddress

    // first remove address from billing address list, this will also remove the default billing address status
    // then add it back to billing address list
    const payload = {
      version: customer.version,
      actions: [
        {
          action: "removeBillingAddressId",
          addressId: targetAddress.id,
        },
        {
          action: "addBillingAddressId",
          addressId: targetAddress.id,
        },
      ],
    }

    try {
      const updatedCustomer = (
        await commerceApi
          .customers()
          .withId({ ID: customer.id })
          .post({
            body: JSON.stringify(payload),
          })
          .execute()
      )?.body

      const updatedTargetAddress = findCustomerTargetAddress(updatedCustomer, addressId)

      return updatedTargetAddress
    } catch (e) {
      throw new Error(e)
    }
  },
}
